import { DiscountRestriction } from '@vista-digital/ocapi-types/v1';
import { configurationSettings } from '../../../../configuration/configuration-settings';
import { getMaximumAllowedMemberRewards } from '../../../loyalty/utils/member-reward-utils';
import { getOrderItemCountByDiscountId } from '../../../order/selectors/items/get-order-item-count-by-discount-id';
import { getOrderItemCountByRewardIds } from '../../../order/selectors/items/get-order-item-count-by-reward-ids';
import { getDiscountById } from '../../selectors/discounts/get-discount-by-id';
export const getAvailableDiscountQuantity = (discountId) => {
    const discount = getDiscountById(discountId);
    if (!discount)
        return 0;
    switch (discount.restriction) {
        case DiscountRestriction.MemberReward:
            return getAvailableMemberRewardCountByDiscount(discount);
        case DiscountRestriction.Voucher:
            return 0;
        case DiscountRestriction.None:
            return configurationSettings.data.order.maximumItemsPerOrder;
        default:
            return 0;
    }
};
export const getAvailableMemberRewardCountByDiscount = (discount) => {
    const maximumAllowedRewardCount = getMaximumAllowedMemberRewards(discount.rewardIds);
    const discountedOrderItemCount = getOrderItemCountByDiscountId(discount.id);
    const rewardOrderItemCount = getOrderItemCountByRewardIds(discount.rewardIds);
    const allowedMaximum = Math.min(maximumAllowedRewardCount, configurationSettings.data.order.maximumItemsPerOrder);
    if (!allowedMaximum)
        return allowedMaximum;
    return allowedMaximum - discountedOrderItemCount - rewardOrderItemCount;
};
